import { render, staticRenderFns } from "./comment-list.vue?vue&type=template&id=4aef7a00&scoped=true&"
import script from "./comment-list.vue?vue&type=script&lang=js&"
export * from "./comment-list.vue?vue&type=script&lang=js&"
import style0 from "./comment-list.scss?vue&type=style&index=0&id=4aef7a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aef7a00",
  null
  
)

export default component.exports